export default {
	"foreuserOrganization": {
		"addUser": "t新增人员",
		"addRoles": "t角色添加"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/foreuserOrganization/foreuserOrganization.js